/**
 * Checks visible header height and positions hidden anchor tag accordingly.
 */
export default function offsetTabBar () {

  const tabAnchor = document.querySelector( '.js-tab-anchor' )
  const header = document.querySelector( '.js-header' )

  if ( !tabAnchor || !header ) {
    return
  }

  let headerHeight = header.offsetHeight

  window.onresize = () => {
    positionTabAnchor()
  }

  /**
   * Updates tab anchor top value.
   */
  function positionTabAnchor() {
    headerHeight = header.offsetHeight
    tabAnchor.style.top = `-${headerHeight}px`
  }

  positionTabAnchor()
}
